import { graphql } from 'react-relay/legacy.js';
import { DEFAULT_QUESTIONS_PER_PAGE } from './constants.ts';

const questionListRootQuery = graphql`
    query questionListRootQuery($first: Int, $page: Int) {
        viewer {
            ...questionListLayout_viewer
            questions(first: $first, page: $page, minAnswersCount: 1) {
                numberOfPages
            }
        }
    }
`;

const questionListVariables = {
    first: DEFAULT_QUESTIONS_PER_PAGE,
    page: 1,
};

export { questionListRootQuery, questionListVariables };
